import React from 'react';
import { createRoot } from 'react-dom/client';
import '@amzn/awsui-global-styles/polaris.css';
import { applyMode, Mode } from '@amzn/awsui-global-styles';
import { App } from './App';

const savedTheme = localStorage.getItem('helianthus-theme');
const mode = savedTheme === 'light' ? Mode.Light : Mode.Dark;
applyMode(mode);

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
